import { Badge, Tooltip } from '@ui';
import { PaymentStatus } from 'components/Mollie/types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentStatusComponent } from '../PaymentStatusComponent';

interface Props {
    status: PaymentStatus;
    paymentId: string;
    className?: string;
    badgeClassName?: string;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    flat?: boolean;
    /**  @deprecated */
    css?: any;
}

/** Badge showing the status of a Mollie payment, with the payment details in its tooltip. */
export const PaymentStatusBadge = ({ paymentId, status, className, badgeClassName, size, flat }: Props) => {
    const { t } = useTranslation('general');
    const renderPaymentStatus = useMemo((): [
        'secondary' | 'success' | 'warning' | 'error' | 'currentColor' | 'light' | undefined,
        string
    ] => {
        switch (status) {
            case 'canceled':
                return ['error', t('mollie.badge.failed')];

            case 'waiting':
            case 'pending':
                return ['warning', t('mollie.badge.processing')];

            case 'paid':
                return ['success', t('mollie.badge.paid')];

            default:
                return ['success', t('mollie.badge.created')];
        }
    }, [status, t]);

    return (
        <Tooltip className={className} trigger="hover" tooltip={<PaymentStatusComponent paymentId={paymentId} />}>
            <Badge className={badgeClassName} color={renderPaymentStatus[0]} size={size} flat={flat}>
                {renderPaymentStatus[1]}
            </Badge>
        </Tooltip>
    );
};
